import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { ICorrespondenceView } from "app/models/mainMenu/mainMenu";

import { ComplaintService } from "app/services/complaint/complaint.service";
import * as moment from "moment";


@Component({
  selector: 'editCorrespondence',
  styleUrls: ['./editCorrespondence.component.scss'],
  templateUrl: './editCorrespondence.component.html'
})

export class EditCorrespondenceComponent implements OnInit {

  savedCorrespondence: boolean = false;
  correspondence: ICorrespondenceView = {} as ICorrespondenceView;
  saveCorr: ICorrespondenceView[] = [];

  form = new UntypedFormGroup({
    generatedDate: new UntypedFormControl('', [this.dateValidator, Validators.required]),
    sentDate: new UntypedFormControl('', [this.dateValidator]),
    visitDate: new UntypedFormControl(''),
    discardedCorrespondence: new UntypedFormControl(''),
    invalidAddress: new UntypedFormControl('')
  });

  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<EditCorrespondenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.correspondence = this.data.correspondence;
  }

  ngOnInit(): void {
    this.setForm(this.correspondence);
  }

  save() {
    this.saveCorr = [];
    if (this.form.valid) {
      this.setData();
      this.saveCorr.push(this.correspondence);
      this.complaintService.saveCorrespondence(this.saveCorr).subscribe({
        next: response => {
          this.sharedService.toastr.success("Saved");
          this.savedCorrespondence = true;
          this.return();
        },
        error: e => {
          this.sharedService.toastr.error("Could not save Correspondence");
        },
      });
    }
    else {
      this.sharedService.toastr.error("Please fill out all required fields");
    }
  }

  return(): void {
    let returnData = this.savedCorrespondence ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

  setForm(data: ICorrespondenceView) {
    this.form.patchValue({
      generatedDate: this.correspondence.generatedDate != null ? new Date(this.correspondence.generatedDate) : '',
      sentDate: this.correspondence.sentDate != null ? new Date(this.correspondence.sentDate) : '',
      discardedCorrespondence: this.correspondence.discardedCorrespondence,
      invalidAddress: this.correspondence.invalidAddress
    });
  }

  setData() {
    this.correspondence.generatedDate = this.datePipe.transform(this.form.controls['generatedDate'].value,'MM/dd/yyyy');
    this.correspondence.sentDate = this.datePipe.transform(this.form.controls['sentDate'].value,'MM/dd/yyyy');
    this.correspondence.discardedCorrespondence = this.form.controls['discardedCorrespondence'].value;
    this.correspondence.invalidAddress = this.form.controls['invalidAddress'].value;
  }

  getType(type: number): string {
    if (type != null && type != undefined) {
      return this.sharedService.getCorrespondenceType(type.toString());
    }
    return '';
  }

  dateValidator(control: FormControl): { [s: string]: boolean } {
    if (control.value) {
      const date = moment(control.value);
      const today = moment();
      if (date.isAfter(today)) {
        return { 'invalidDate': true }
      }
    }
    return null;
  }
}